const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_onboarding.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
import { getOnboardingCompletionDestination } from "@/lib/getOnboardingCompletionDestination";
import { buildLoginHrefWithRedirect, getRedirectPathFromLocation } from "@/lib/redirect-after-login";
import { pickString } from "@/lib/search-params";
import { getSafeRedirectPath } from "@garimpa/lib/getSafeRedirectPath";
interface OnboardingSearch {
  redirect?: string;
}
export const Route = createFileRoute("/_onboarding")({
  // Gates onboarding while preserving the original destination through login:
  //   - no session              → /login?redirect=/onboarding...
  //   - onboarding already done → /welcome (outside this layout, so no loop);
  //     the wizard calls router.invalidate() after completing.
  validateSearch: (raw: Record<string, unknown>): OnboardingSearch => ({
    redirect: getSafeRedirectPath(pickString(raw.redirect))
  }),
  beforeLoad: async ({
    context: {
      viewer
    },
    location,
    search
  }) => {
    const user = viewer.user;
    if (!user) {
      throw redirect({
        href: buildLoginHrefWithRedirect(getRedirectPathFromLocation(location))
      });
    }
    if (user.isAnonymous) {
      throw redirect({
        href: "/taste"
      });
    }
    if (user.onboardingComplete) {
      throw redirect({
        href: getOnboardingCompletionDestination(search.redirect)
      });
    }
    return {
      redirectAfterOnboarding: search.redirect,
      user,
      viewerPreferences: viewer.preferences
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});